import { memo } from 'react';
import { ListItem } from '../common/Listitem';

import './FooterLink.scss';

export const FooterLinkSeparator = memo(() => (
    <span aria-hidden className="footer__link-separator">
        &middot;
    </span>
));

export interface FooterLinkProps {
    href: string;
    openInNewWindow?: boolean;
    text: string;
}

export const FooterLink = memo(
    ({ href, openInNewWindow, text }: FooterLinkProps) => (
        <ListItem>
            <a
                className="footer__link"
                dangerouslySetInnerHTML={{ __html: text }}
                href={href}
                rel={openInNewWindow ? 'noreferrer' : undefined}
                target={openInNewWindow ? '_blank' : undefined}
            />
        </ListItem>
    )
);
